import { useSearchParams } from "react-router-dom";
import { VoiceAccountDetail, type AccountTab } from "@/components/voice-account/VoiceAccountDetail";
import BillingTab from "./tabs/BillingTab";
import DevelopersTab from "./tabs/DevelopersTab";
import ProfileTab from "./tabs/ProfileTab";
import SecurityTab from "./tabs/SecurityTab";
import TroubleshootingTab from "./tabs/TroubleshootingTab";

const VALID_TABS: AccountTab[] = ["profile", "security", "billing", "developers", "troubleshooting"];

/**
 * /genie-hub/account — immersive Account view (5 tabs in one route via `?tab=`,
 * default "profile"). The shared VoiceAccountDetail provides the chrome; this
 * picks the active tab body. Leaves /genie-hub/account-settings untouched.
 */
const VoiceAccountPage = () => {
  const [searchParams] = useSearchParams();
  const tabParam = (searchParams.get("tab") as AccountTab | null) ?? "profile";
  const active: AccountTab = VALID_TABS.includes(tabParam) ? tabParam : "profile";

  const body =
    active === "security" ? (
      <SecurityTab />
    ) : active === "billing" ? (
      <BillingTab />
    ) : active === "developers" ? (
      <DevelopersTab />
    ) : active === "troubleshooting" ? (
      <TroubleshootingTab />
    ) : (
      <ProfileTab />
    );

  return <VoiceAccountDetail active={active}>{body}</VoiceAccountDetail>;
};

export default VoiceAccountPage;
